const queryPack = (info: any) => {
  let query = ''
  // eslint-disable-next-line array-callback-return
  Object.keys(info).map((k) => {
    query += `${k}=${encodeURIComponent(info[k])}&`
  })
  return query.substr(0, query.length - 1)
}
const LotteryReport = (
  action: 'lottery_view' | 'lottery_add_to_cart' | 'lottery_checkout'
) => {
  const lotteryApiAddress = process.env.NEXT_PUBLIC_LOTTERY_API_ADDRESS
  const email = localStorage.getItem('lottery_email')
  const query = queryPack({ email, action })

  if (action && email && !localStorage.getItem(action)) {
    fetch(`${lotteryApiAddress}/shopify/lottery/behavior?${query}`)
      .then((response) => response.json())
      .then(() => {
        // eslint-disable-next-line no-console
        localStorage.setItem(action, 'OK')
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
  }
}

export default LotteryReport
